export default __webpack_public_path__ + "static/media/7.55ab6331.jpg";